<template>
 <div class="row banner" v-bind:class="{ 'full': isActive }">
          <!-- Greek Democracy -->
          <div class="col-md-6">
          <div class="row">
            <div class="col-md-6 col-xs-6"><img src="@/assets/eldi-ypekky.svg" alt=""></div>
            <div class="col-md-6 col-xs-6 text">Πρόγραμμα «Οικονομικής Στήριξης Οικογενειών με Παιδιά Προσχολικής Ηλικίας» Περιόδου 2021-2022</div>
          </div>
          </div>
          <!-- ESPA -->
          <div class="col-md-6">
            <div class="col-md-3 col-xs-3"><img src="@/assets/espa-logo.svg" alt=""></div>
            <div class="col-md-6 col-xs-6 text">Δράση «Εναρμόνιση Οικογενειακής<br>και Επαγγελματικής Ζωής»<br>Περιόδου 2021-2022</div>        
            <div class="col-md-3 col-xs-3"><img src="@/assets/flag-europe-europian-cash-otl.svg" alt=""></div>
          </div>
        </div>
</template>

<script>

export default {
    data(){
        return{
            isActive: true
        }
    },
    computed:{
        isAuthenticated(){
            return  this.$store.getters.isAuthenticated;
        },
    },
     created(){
         if(this.isAuthenticated){
             this.isActive = false;
         }
     }
};
</script>

<style lang="scss" scoped>

.row.banner {
    padding: 0.25rem;
    background-color: transparent;
    margin: 0 auto;

    &.full{
         width: 100%;
        //margin-left: -20%;
    }
   

    div[class^="col-md-"] {
      height: 100px;
      display: flex;
      align-items: center;
      font-size: 0.55rem;
      padding: 0 5px;

      .text {
        padding: 5px;
      }
    }

    img {
      max-width: 100%;
      vertical-align: middle;
    }
  }

@media (max-width: 767px) {
  .row.banner {
    padding: 0.25rem 4rem;
    background-color: transparent;
    margin: 0 auto;
    
    &.full{
         width: 120%;
        margin-left: -10%;
    }

    div[class^="col-md-"] {
      height: 100px;
      display: flex;
      align-items: center;
      font-size: 0.55rem;
      padding: 0 5px;

      .text {
        padding: 5px;
      }
    }

    img {
      max-width: 100%;
      vertical-align: middle;
    }
  }
}
@media (min-width: 768px) {
  .row.banner {
    padding: 0.25rem 4rem;
    background-color: transparent;
    margin: 0 auto;


    div[class^="col-md-"] {
      height: 100px;
      display: flex;
      align-items: center;
      font-size: 0.75rem;
      padding: 0 10px;

      .text {
        padding: 15px;
      }
    }

    img {
      max-width: 90%;
      vertical-align: middle;
    }
  }
}
@media (min-width: 992px) {
}
@media (min-width: 1200px) {
}

</style>